// extracted by mini-css-extract-plugin
export default {"picture":"Aeyp7"};